import React from 'react';
import { Helmet } from 'react-helmet';
import { Container } from 'reactstrap';
import ChangeStaffPasswordForm from 'components/Form/Tenant/ChangeStaffPasswordForm';

const ChangeStaffPasswordPage: React.FC = () => {
  return (
    <div className="page-content">
      <Helmet>
        <title>Change Employee Password</title>
      </Helmet>
      <Container fluid>
        <ChangeStaffPasswordForm />
      </Container>
    </div>
  );
};

export default ChangeStaffPasswordPage;
